import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    messages: [],
    token: null,
}

const signalRMessagesSlice = createSlice({
    name: "signalRMessages",
    initialState,
    reducers: {
        initToken(state, action) {
            state.token = action.payload;
        },
        addMessage(state, action) {
            const { lessonId, message, userFrom, studyGroupId } = action.payload;
            state.messages.push({ lessonId, message, userFrom, studyGroupId });
        },
        updateMessage(state, action) {
            const { givenControl } = action.payload;
            const lastMessage = state.messages[state.messages.length - 1];
            if (lastMessage) {
                lastMessage.givenControl = givenControl;
            }
        },
        updateReadMessage(state, action) {
            const { isRead } = action.payload;
            const lastMessage = state.messages[state.messages.length - 1];
            if (lastMessage) {
                lastMessage.isRead = isRead;
            }
        },
    }
})

export const signalRMessagesActions = signalRMessagesSlice.actions;
export default signalRMessagesSlice
